<template>
  <div id="stree"></div>
</template>
<script>
export default {
  methods: {
    stree(lng, lat) {
      console.log(lng,lat)
      var panorama = new BMap.Panorama("stree");
      panorama.setPosition(new BMap.Point(lng, lat));
    },
    close() {
      this.$emit("close", false);
    }
  },
};
</script>
<style lang="">
#stree {
  height: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/locate/com/stree.vue